import Header from '../components/Header';

const Section = ({ title, children }) => (
  <section className="mb-8">
    <h2 className="font-serif text-xl text-white font-bold mb-3">{title}</h2>
    <div className="text-white/75 text-sm leading-relaxed space-y-3">{children}</div>
  </section>
);

export default function TermsPage() {
  return (
    <div className="min-h-screen relative">
      <div className="fixed inset-0 -z-10 bg-gradient-to-br from-ocean via-ocean-light/90 to-sky/70" />
      <Header />
      <main className="pt-24 pb-20 px-4 sm:px-6 md:px-12 lg:px-24">
        <div className="max-w-3xl mx-auto bg-white/10 backdrop-blur-xl border border-white/15 rounded-2xl p-6 sm:p-10" data-testid="terms-page">
          <h1 className="font-serif text-3xl text-white font-bold mb-2">Terms & Conditions</h1>
          <p className="text-white/50 text-sm mb-8">Last updated: April 2026</p>

          <Section title="1. Acceptance of Terms">
            <p>By accessing and using Triple A Travel Solutions ("the Service"), you agree to be bound by these Terms & Conditions. If you do not agree to these terms, please do not use our Service.</p>
          </Section>

          <Section title="2. Service Description">
            <p>Triple A Travel Solutions provides AI-powered travel planning, itinerary generation, booking referrals, and travel advisory services. Our platform uses artificial intelligence to generate personalised itineraries, budget estimates, packing lists, and travel recommendations.</p>
            <p>We act as an intermediary connecting you with third-party travel service providers including airlines, hotels, tour operators, insurance providers, and transportation companies.</p>
          </Section>

          <Section title="3. AI-Generated Content Disclaimer">
            <p>Our AI-generated itineraries, recommendations, visa information, and budget estimates are provided for informational and planning purposes only. While we strive for accuracy, AI-generated content may contain errors or outdated information. Users should independently verify all critical travel details including visa requirements, entry regulations, health advisories, and pricing with official government and provider sources.</p>
          </Section>

          <Section title="4. Third-Party Bookings & Affiliate Links">
            <p>Triple A Travel Solutions provides links to third-party booking platforms (including Expedia, Booking.com, Aviasales, and others) through affiliate partnerships. When you click these links and make a purchase, we may earn a commission at no additional cost to you.</p>
            <p>All bookings made through third-party platforms are subject to the terms and conditions of those respective providers. Triple A Travel Solutions is not responsible for the services, policies, pricing, cancellations, or refunds of third-party providers.</p>
          </Section>

          <Section title="5. User Accounts">
            <p>You are responsible for maintaining the confidentiality of your account credentials and for all activities that occur under your account. You agree to provide accurate and current information during registration and to update your information as necessary.</p>
          </Section>

          <Section title="6. Cancellations & Refunds">
            <p>As Triple A Travel Solutions acts as an intermediary, cancellations and refunds for bookings made through third-party providers are governed by those providers' respective policies. We will assist where possible but cannot guarantee refunds from third-party services.</p>
            <p>For our direct services (personalised trip planning, VIP arrangements), cancellation terms will be communicated at the time of engagement.</p>
          </Section>

          <Section title="7. Limitation of Liability">
            <p>Triple A Travel Solutions shall not be liable for any indirect, incidental, special, or consequential damages arising from your use of the Service, including but not limited to: travel disruptions, flight delays/cancellations, accommodation issues, loss of personal property, or reliance on AI-generated information.</p>
          </Section>

          <Section title="8. Modifications">
            <p>We reserve the right to modify these Terms at any time. Continued use of the Service after changes constitutes acceptance of the updated Terms.</p>
          </Section>

          <Section title="9. Contact">
            <p>For questions about these Terms, contact us at <a href="mailto:triplea@tripleabooking.com" className="text-gold hover:underline">triplea@tripleabooking.com</a> or call +61 401 050 457.</p>
          </Section>
        </div>
      </main>
    </div>
  );
}
